import { render, staticRenderFns } from "./ActivityQuestion.vue?vue&type=template&id=147bacb0&scoped=true&"
import script from "./ActivityQuestion.vue?vue&type=script&lang=js&"
export * from "./ActivityQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ActivityQuestion.vue?vue&type=style&index=0&id=147bacb0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147bacb0",
  null
  
)

export default component.exports